import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { AgencySubscriptionItemDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import {
  CurrencyFormat,
  DecimalFormat,
} from "@src/features/admin/components/utils";

interface SummaryProps {
  item: AgencySubscriptionItemDto;
}
export const Summary = ({ item }: SummaryProps) => {
  return (
    <Grid
      item
      container
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Grid item ml={1.5}>
        <IgTypography igStyle={"semibold"}>{item.product.name}</IgTypography>
      </Grid>
      <Grid item mr={1.5}>
        <IgTypography variant={"body2"}>
          {DecimalFormat.format(item.meter.totalMeterValue)}{" "}
          {item.meter.meterUnit} |{" "}
          {CurrencyFormat.format(item.meter.totalMeterCost)}
        </IgTypography>
      </Grid>
    </Grid>
  );
};
